module.exports = require("vtk.js/Sources/Interaction/Style/InteractorStyleManipulator");